
import { useParsedFieldProps } from "./useParsedFieldProps";
import { useCheckboxesSchema } from "./useCheckboxesSchema";
import { CHECKBOXES_MULTI_SELECT } from "../SchemaTypes";
import Field from "../Field";
import CheckboxesMultiSelectInput from "../../Input/CheckboxesMultiSelectInput";

const CheckboxesMultiSelectField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, maximumSelectableOptions, parent } = props;

  const schema = useCheckboxesSchema({
    type: CHECKBOXES_MULTI_SELECT,
    singleOptionSelection: false,
    required,
    parent,
    maximumSelectableOptions
  });

  return (
    <Field {...fieldProps} schema={schema}>
      <CheckboxesMultiSelectInput {...inputProps} />
    </Field>
  );
};

export default CheckboxesMultiSelectField;
